import { create } from 'zustand';

interface GlobalErrorStoreData {
    message: string | null;
    showError: (message: string) => void;
    clearError: () => void;
}

export const useGlobalErrorStore = create<GlobalErrorStoreData>((set) => ({
    message: null,
    showError: (message) => set({ message }),
    clearError: () => set({ message: null }),
}));
